import localStorage from "../services/localStorage/localStorage";

const FCM_TOKEN = "fcmToken";

export const setFcmTokenToStorage = (value: string): void => localStorage.set(FCM_TOKEN, value);
export const getFcmTokenFromStorage = (): string | null => localStorage.get(FCM_TOKEN, null) as string | null;
